import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { url: String }

  loadSubcategories (event) {
    const category = event.target.value
    if (!category) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('item[category]', category)

    fetch(url, {
      headers: {
        Accept: 'text/vnd.turbo-stream.html'
      }
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }
}
